// src/components/PaymentModal.js
import React, { useState } from "react";
import "../styles/paymentModal.css";

/* =====================================================
   Helpers
===================================================== */

// DEV detection (used everywhere else in app)
const isDevEmail = (email) =>
  typeof email === "string" && email.endsWith("@dev.edgeneweb");

/* =====================================================
   Component
===================================================== */
const PaymentModal = ({
  isOpen,
  onClose,
  plan,
  userEmail,
  onPaymentComplete,
}) => {
  const [paymentStatus, setPaymentStatus] = useState("idle");
  // idle | processing | success | error

  if (!isOpen || !plan) return null;

  /* =====================================================
     Handlers
  ===================================================== */

  const handlePayNow = () => {
    setPaymentStatus("processing");

    // Simulate real Paystack processing delay
    setTimeout(() => {
      setPaymentStatus("success");

      setTimeout(() => {
        // Simulated Paystack success payload
        onPaymentComplete?.({
          reference: `MOCK-PAYSTACK-${Date.now()}`,
          amount: plan.paystackAmount,
          email: userEmail,
          status: "success",
        });
      }, 1000);
    }, 2000);
  };

  const handleCancel = () => {
    setPaymentStatus("idle");
    onClose();
  };

  /* =====================================================
     Render
  ===================================================== */
  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        {/* Header */}
        <div className="payment-modal-header">
          <h2>Paystack Checkout</h2>
          <button
            className="close-button"
            onClick={handleCancel}
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="payment-modal-body">
          <p>
            <strong>Plan:</strong> {plan.title}
          </p>
          <p>{plan.description}</p>
          <p>
            <strong>Amount:</strong> {plan.price}
          </p>
          <p>
            <strong>Email:</strong> {userEmail}
          </p>

          {isDevEmail(userEmail) && (
            <div className="dev-banner">
              DEV MODE — Mock Paystack (no real charge)
            </div>
          )}

          {paymentStatus === "processing" && (
            <p className="processing">
              Processing payment… Please wait
            </p>
          )}

          {paymentStatus === "success" && (
            <p className="success">
              ✅ Payment successful! Redirecting…
            </p>
          )}
        </div>

        {/* Footer */}
        {paymentStatus === "idle" && (
          <div className="payment-modal-footer">
            <button
              className="pay-now-button"
              onClick={handlePayNow}
            >
              Pay with Paystack
            </button>

            <button
              className="cancel-button"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;